<section class="team-section" id="staff">
  <div class="section-container">
    <div class="section-header">
      <div class="header-badge">
        <span class="badge-icon">👥</span>
        <span class="badge-text">Our Team</span>
      </div>
      <h2 class="section-title">Meet Our Expert Educators</h2>
      <p class="section-subtitle">
        Passionate professionals dedicated to providing exceptional educational experiences
      </p>
    </div>
    <div class="team-grid">
      <div class="team-member" *ngFor="let member of staffMembers; let i = index">
        <div class="member-avatar">
          <div class="avatar-circle" [class]="getAvatarColor(i)">
            <span class="avatar-initials">{{ getInitials(member.name) }}</span>
          </div>
          <div class="avatar-glow"></div>
        </div>
        <div class="member-info">
          <h3 class="member-name">{{ member.name }}</h3>
          <p class="member-role">{{ member.role }}</p>
          <p class="member-bio">{{ member.bio }}</p>
        </div>
        <div class="member-specialties">
          <div class="specialty-item" *ngFor="let specialty of member.specialties">
            <span class="specialty-tag">{{ specialty }}</span>
          </div>
        </div>
        <div class="member-shine"></div>
      </div>
    </div>
  </div>
</section>